import React from "react";
import Header from "./Header";
import HeaderMobile from "./newHeaderMobil";
import Footer from "./Footer";
import HeaderPage from "./../components/common/HeaderPage";
import { Container } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import ScrollToTop from "./ScrollToTop/ScrollToTop";



export default function ErrorPage404({home}) {

  
  let dataMenu = [
    {
        label: "سرمایه‌گذاری",
        route: "/",
        child: [
            {
                label: "از کجا شروع کنیم",
                route: "/",
                child: [
                    {
                        label: "شروع سرمایه‌گذاری",
                        route: "/Investment",
                    },
                    {
                        label: "سوالات متداول",
                        route: "/faq",
                    },
                    {
                        label: "اخبار و آموزش بورس ",
                        route: "https://mag.pouyanbroker.com/",
                        badge: {
                            title: 'مجله پویان'
                        }
                    },
                    // {
                    //     label: "آموزش",
                    //     route: "/education",
                    // },
                ],
            },
            {
                label: "سامانه‌های معاملاتی",
                route: "/",
                child: [
                    {
                        label: "سامانه آنلاین",
                        route: "/Trades",
                    },
                    {
                        label: "تغییر پنل معاملاتی",
                        route: "/",
                
                    },
                    {
                        label: "پنل خدمات مشتریان",
                        route: "https://my.pouyanbroker.ir",
                    },
                ],
            },
        ]
    },
    {
        label: "معاملات آنلاین",
        route: "/",
        child: [
            {
                label: "اوراق بهادار",
                route: "/",
                child: [
                    {
                        label: "درباره اوراق بهادار",
                        route: "/oragh",
                    },
                    {
                        label: "درباره کد بورسی و سجام",
                        route: "https://reg.pouyanbroker.ir/auth/phone",
                    },
                    {
                        label: "فایل‌های آموزشی",
                        route: "/education",
                    },
                ],
            },
            {
                label: "بورس کالا",
                route: "/",
                child: [
                    {
                        label: "درباره بورس کالا",
                        route: "/kala",
                    },
                    {
                        label: "معاملات آتی کالا",
                        route: "https://pouyan.ebgo.ir/Login",
                    },
                    {
                        label: "خرید خودرو در بورس",
                        route: "/khodro",
                    },
                    // {
                    //     label: "اطلاعیه های عرضه",
                    //     route: "/bourseKala",
                    // },
                    // {
                    //     label: "درباره بورس کالا",
                    //     route: "/kala",
                    // },
                    // {
                    //     label: "معاملات مشتقه کالا (آتی)",
                    //     route: "https://pouyan.ebgo.ir/Login",
                    // },
                    // {
                    //     label: "اخبار و تحلیل‌ها",
                    //     route: "/",
                    // },
                    // {
                    //     label: "ثبت نام خرید خودرو",
                    //     route: "/khodro",
                    // },
                    // {
                    //     label: "اطلاعیه های عرضه،آمار معاملات",
                    //     route: "/bourseKala",
                    // },
                ],
            },
            {
                label: "بورس انرژی",
                route: "/",
                child: [
                    {
                        label: "درباره بورس انرژی",
                        route: "/energy",
                    },
                ],
            },
        ]
    },
    {
        label: "شعب و دفاتر",
        route: "/Shoab",
        child: []
    },
    {
        label: "درباره پویان",
        route: "/",
        child: [
            {
                label: "آشنایی با پویان",
                route: "/AboutUs",
                child: [
                    {
                        label: "مدیران",
                        route: "/MangementUsers",
                    },
                    {
                        label: "شعب و دفاتر",
                        route: "/Shoab",
                    },
                    {
                        label: "شماره حسا‌ب‌ها",
                        route: "/AcountNumber",
                    },
                    {
                        label: "درباره پویان",
                        route: "/AboutUs",
                    },
                    {
                        label: " ارتباط با ما",
                        route: "/ContactUs",
                    },
                ],
            },
        ]
    },
    {
        label: "مجله پویان",
        route: "https://mag.pouyanbroker.com/",
        child: []
    },
]

  return (

    <Container maxWidth="" style={{ padding: 0 }}>
      <div id="back-to-top-anchor">
        <Hidden smDown>
          <Header home={home} data={dataMenu} />
        </Hidden>

        <Hidden mdUp style={{ width: '100%' }}>
          <HeaderMobile home={home} data={dataMenu} />
        </Hidden>
      </div>

      <div className="d-flex  flex-column flex-root" style={{ width: "100%", height: "59vh", zIndex: "10000000",border:'1px solid rgba(0,0,0,0.1)' }}>
        <div
          className="d-flex flex-row-fluid flex-column p-5 w-100 h-100 text-center align-items-center justify-content-start"
          style={{
            backgroundImage: `url("/assets/images/bg1.jpg")`,
            backgroundPosition:'left',
          }}
        >
          <h1
            className=""
            style={{ fontSize: "100px" , }}
          >
            404
          </h1>
          <h3 className="">
           صفحه مورد نظر یافت نشد.
          
            </h3>
          <h5 className="">
            <a className="text-danger" href="/"> بازگشت به صفحه اصلی </a>
            </h5>
        </div>
      </div>
      <div>
        <Footer />
      </div>

      <ScrollToTop />
    </Container>

 
  );
}
